export const USE_CLASSES = {
  default: 'uiPopover--default private-popover--default',
  longform: 'private-tooltip--longform',
  shepherd: 'private-popover--shepherd',
  tooltip: 'private-popover--tooltip',
  'tooltip-danger': 'private-popover--tooltip private-popover--tooltip-danger',
  unstyled: 'private-popover--unstyled',
} as const;
